import { soundToPlay } from "../sounds/sound";
import Character from "./Character";

export class Mage extends Character {

    dealDamage(dmgToCharacter: Character) {
        soundToPlay("magic")
        this.decSkillsCooldown()
        const dmg = Math.floor(Math.random() * (this.getDamage() - 1 + 1) + 1)
        dmgToCharacter.setHp(dmgToCharacter.getHp() - (dmg))
    }

    firstSkill(enemiesArr: Character[], enemiesIndex: number) {
        const arrToDealDamage = enemiesArr.slice(enemiesIndex)
        arrToDealDamage.length = 2
        soundToPlay("magic")
        this.decSkillsCooldown()
        this.setSkillCooldown(1, 2)
        arrToDealDamage.forEach((element) => {
            if (this.calcMod(this.getInt()) >= this.calcMod(element.getWis())) {
                const dmg = Math.floor(Math.random() * (6 - 1 + 1) + 1) + this.calcMod(this.getInt())
                element.setHp(element.getHp() - (dmg))
            }
        })
    }

    secondSkill(enemiesArr: Character[]): void {
        soundToPlay("magic")
        this.decSkillsCooldown()
        this.setSkillCooldown(2, 3)
        enemiesArr.forEach(element => {
            if (this.calcMod(this.getInt()) >= this.calcMod(element.getWis())) {
                const dmg = Math.floor(Math.random() * (10 - 1 + 1) + 1) + this.calcMod(this.getInt())
                element.setHp(element.getHp() - (dmg))
            }
        })
    }

    thirdSkill(enemiesArr: Character, enemiesIndex: number): void {
        soundToPlay("magic")
        this.decSkillsCooldown()
        this.setSkillCooldown(3, 4)
        const dmg = (Math.floor(Math.random() * (this.getDamage() - 1 + 1) + 1))
        if (this.calcMod(this.getInt()) >= this.calcMod(enemiesArr.getWis())) {
            enemiesArr.setHp(enemiesArr.getHp() - dmg)
            this.selfHeal(dmg)
        }
    }

}